@if (!hidden()) {
  <div class="wrapper">
    @if (label(); as label) {
      <onyx-input-label
        [disabled]="disabled()"
        [required]="required()"
        [label]="label"
        [hint]="hint()"
        [link]="link()"
        (click)="focus()"
      >
        @if (!disabled() && maxLengthHint()) {
          <p content>{{ maxLengthHint() }}</p>
        }
      </onyx-input-label>
    }

    <div class="container">
      <textarea
        class="textarea"
        [class.resize]="resize()"
        [class.disabled]="disabled()"
        [class.invalid]="isInvalid()"
        [class.active]="value()"
        [style.min-height]="minResizeHeight()"
        [style.max-height]="maxResizeHeight()"
        [disabled]="disabled()"
        [value]="value() ?? ''"
        [attr.placeholder]="placeholder() ?? '' | translate"
        (input)="handleValueChange($event)"
        (focusout)="touch.emit()"
        #textareaElement
      ></textarea>
    </div>
  </div>

  @let control = formField() ?? formControl();
  @if (control && showErrors()) {
    <onyx-error [errors]="[control]" variant="control"></onyx-error>
  }
}
